
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getVersions"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "118fb3108a94224e0301.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			